import React from 'react';
import { connect } from 'react-redux';
import { openOrderJournalDetailDialog } from '@/actions/app';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import DataTable from '@/components/DataTable/DataTable';
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

class OrderHistory extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.defaultColumnDefs= () => [
      {
        headerName: this.props.language.common_actions,
        colId: 'common_actions',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell',
        dataType: dataType.EDIT_CANCEL,
        cellRendererParams: {
          onEditOrder: this.handleEditOrder,
          onCancelOrder: this.handleCancelOrder,
        },
        sortable: false,
        minWidth: 60,
        maxWidth: 80
      },
      {
        headerName: this.props.language.common_order_id,
        colId: 'common_order_id',
        field: 'orderGroupID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        cellRendererParams: {
          action: this.handleViewOrderDetail
        },
        minWidth: 80,
        maxWidth: 200

      },
      {
        headerName: this.props.language.common_symbol,
        colId: 'common_symbol',
        field: 'instrumentID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        cellRendererParams: {
          market: 'marketID',
          instrument: 'instrumentID'
        },
        minWidth: 160,
        maxWidth: 230
      },
      {
        headerName: this.props.language.common_name,
        colId: 'common_name',
        field: 'instrumentName',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.STOCK_NAME,
        cellRendererParams: {
          stockName: 'instrumentName',
          chineseStockName: 'instrumentChineseName'
        },
        minWidth:260,
        maxWidth:350
      },
      {
        headerName: this.props.language.common_ccy,
        colId: 'common_ccy',
        field: 'currencyID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        minWidth: 50,
        maxWidth:100
      },
      {
        headerName: this.props.language.common_buy_sell,
        colId: 'common_buy_sell',
        field: 'bs',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell text-center',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 80,
        maxWidth: 100
      },
      {
        headerName: this.props.language.common_price,
        colId: 'common_price',
        field: 'price',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.CURRENCY,
        minWidth: 60,
        maxWidth:160
      },
      {
        headerName: this.props.language.common_quantity,
        colId: 'common_quantity',
        field: 'qty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.NUMBER,
        minWidth:114,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_filled_qty,
        colId: 'common_filled_quantity',
        field: 'filledQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.NUMBER,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_outstanding_quantity,
        colId: 'common_outstanding_quantity',
        field: 'osQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.NUMBER,
        minWidth: 120,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_avg_price,
        colId: 'common_avg_price',
        field: 'avgPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.AVG_PRICE,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_status,
        colId: 'common_status',
        field: 'status',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 100,
        maxWidth:140
      },
      {
        headerName: this.props.language.common_order_type,
        colId: 'common_order_type',
        field: 'orderType',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 135,
        maxWidth: 200
      },
      {
        headerName: this.props.language.common_stop_price,
        colId: 'common_stop_price',
        field: 'stopPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.CURRENCY,
        minWidth: 90,
        maxWidth: 160
      },
      {
        headerName: this.props.language.common_create_time,
        colId: 'common_create_time',
        field: 'inputTime',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.LONG_DATE,
        minWidth: 130,
        maxWidth: 240
      }
    ]
    this.fundColumnDefs= () => [
      {
        headerName: this.props.language.common_actions,
        colId: 'funds_common_actions',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell',
        dataType: dataType.EDIT_CANCEL,
        cellRendererParams: {
          onEditOrder: this.handleEditOrder,
          onCancelOrder: this.handleCancelOrder,
        },
        sortable: false,
        minWidth: 60,
        maxWidth: 80
      },
      {
        headerName: this.props.language.common_order_id,
        colId: 'funds_common_order_id',
        field: 'orderID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        cellRendererParams: {
          action: this.handleViewOrderDetail
        },
        minWidth: 80,
        maxWidth: 200
      },
      {
        headerName: this.props.language.common_funds_market_id,
        colId: 'funds_common_market_id',
        field: 'marketID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 80,
        maxWidth:120
      },
      {
        headerName: this.props.language.funds_instrument_id,
        colId: 'funds_instrument_id',
        field: 'instrumentID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 160,
        maxWidth: 230
      },
      {
        headerName: this.props.language.funds_instrument_name,
        colId: 'funds_instrument_name',
        field: 'instrumentName',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        minWidth:380,
      },
      {
        headerName: this.props.language.common_ccy,
        colId: 'funds_common_ccy',
        field: 'currencyID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        minWidth: 50,
        maxWidth:100
      },
      {
        headerName: this.props.language.common_buy_sell,
        colId: 'funds_buy_sell',
        field: 'bs',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell text-center',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 80,
        maxWidth: 100
      },
      {
        headerName: this.props.language.common_price,
        colId: 'funds_price',
        field: 'price',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.CURRENCY,
        minWidth: 60,
        maxWidth:160
      },
      {
        headerName: this.props.language.common_quantity,
        colId: 'funds_quantity',
        field: 'qty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        minWidth:114,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_filled_qty,
        colId: 'funds_filled_quantity',
        field: 'filledQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_outstanding_quantity,
        colId: 'funds_outstanding_quantity',
        field: 'osQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        minWidth: 120,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_avg_price,
        colId: 'funds_avg_price',
        field: 'avgPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.AVG_PRICE,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_status,
        colId: 'funds_status',
        field: 'status',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 100,
        maxWidth:140
      },
      // {
      //   headerName: this.props.language.common_order_type,
      //   colId: 'funds_order_type',
      //   field: 'orderType',
      //   headerClass: 'table-header',
      //   cellClass: 'table-cell',
      //   dataType: dataType.ORDER_CELL_RENDER,
      //   minWidth: 135,
      //   maxWidth: 200
      // },
      // {
      //   headerName: this.props.language.common_stop_price,
      //   colId: 'funds_stop_price',
      //   field: 'stopPrice',
      //   headerClass: 'table-header text-end',
      //   cellClass: 'table-cell',
      //   dataType: dataType.CURRENCY,
      //   minWidth: 90,
      //   maxWidth: 160
      // },
      {
        headerName: this.props.language.common_create_time,
        colId: 'funds_create_time',
        field: 'inputTime',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.LONG_DATE,
        minWidth: 130,
        maxWidth: 240
      }
    ]
    this.state = {
      data: null,
      columnDefs: this.defaultColumnDefs(),
      dateFilter: null
    }
  }
  render() {
    const { data, columnDefs } = this.state;
    return (
      <div className="order-history-container" style={{ flexGrow: 1 }}>
        <DataTable
          name={TABLE_CONFIGURABLE_KEYS.TRADE_PORTFOLIO_ORDER_HISTORY}
          innerRef={e => this.tableRef = e}
          columnDefs={columnDefs}
          data={data}
        />
      </div>
    )
  }

  handleViewOrderDetail = (order) => {
    openOrderJournalDetailDialog(order, this.state.dateFilter, true)
  }

  getData(status = '', startDate = '', endDate = '',marketID = '') {
    this.setState({data:[]})
    const { currentTradingAccount, language ,token} = this.props
    if (currentTradingAccount.clientID) {
      if (this.tableRef) {
        this.tableRef.toggleLoadingOverlay(true);
      }

      let dateFilter = {
        startDate: startDate,
        endDate: endDate
      }
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: status,
        [PARAMS.START_DATE]: startDate,
        [PARAMS.END_DATE]: endDate,
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID
      }

      this.setState({ dateFilter: dateFilter })

      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ 
              data: res.result.orderInfoList ,
              columnDefs: marketID == "FUND" ? this.fundColumnDefs() : this.defaultColumnDefs()
            });
          } else {
            this.setState({
              data: []
            })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  getYesterday() {
    let date = new Date();
    date.setDate(date.getDate() - 1); // get yesterday
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  componentDidMount() {
    // this.getData('', this.getYesterday(), this.getYesterday(),'');
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
  	if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
    	// this.getData('', this.getYesterday(), this.getYesterday());
  	}
  }
}

OrderHistory.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    token: state.auth.token
  }),
  dispatch => ({
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c))
  })
)(OrderHistory)
